import React, {Component} from 'react';

export default class open extends Component{
    render(){

        return (
            <div>{this.props.children}</div>
        )
    }
}
